import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0522dfda = () => interopDefault(import('../pages/affiliates.vue' /* webpackChunkName: "pages/affiliates" */))
const _6772f473 = () => interopDefault(import('../pages/analysis/index.vue' /* webpackChunkName: "pages/analysis/index" */))
const _16303fbc = () => interopDefault(import('../pages/analytics.vue' /* webpackChunkName: "pages/analytics" */))
const _3e8adfbc = () => interopDefault(import('../pages/api-docs.vue' /* webpackChunkName: "pages/api-docs" */))
const _12f1648c = () => interopDefault(import('../pages/apply-promo.vue' /* webpackChunkName: "pages/apply-promo" */))
const _8ab580aa = () => interopDefault(import('../pages/automation.vue' /* webpackChunkName: "pages/automation" */))
const _5c5a4fb9 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _41722a66 = () => interopDefault(import('../pages/BlogPostWrapper.vue' /* webpackChunkName: "pages/BlogPostWrapper" */))
const _3e8cdac2 = () => interopDefault(import('../pages/campaigns/index.vue' /* webpackChunkName: "pages/campaigns/index" */))
const _1b61f830 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _42f6eca9 = () => interopDefault(import('../pages/dms/index.vue' /* webpackChunkName: "pages/dms/index" */))
const _bb23bed8 = () => interopDefault(import('../pages/features/index.vue' /* webpackChunkName: "pages/features/index" */))
const _e5377492 = () => interopDefault(import('../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _1e45c539 = () => interopDefault(import('../pages/import.vue' /* webpackChunkName: "pages/import" */))
const _62f3dfbe = () => interopDefault(import('../pages/list-of-nsfw-subreddits.vue' /* webpackChunkName: "pages/list-of-nsfw-subreddits" */))
const _fc4226c4 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _9601a1f4 = () => interopDefault(import('../pages/plans.vue' /* webpackChunkName: "pages/plans" */))
const _a1bfefb8 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1a9bd0fa = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _6c917ab6 = () => interopDefault(import('../pages/signin.vue' /* webpackChunkName: "pages/signin" */))
const _89da128a = () => interopDefault(import('../pages/stats.vue' /* webpackChunkName: "pages/stats" */))
const _5fd4c9c3 = () => interopDefault(import('../pages/submissions.vue' /* webpackChunkName: "pages/submissions" */))
const _4f796228 = () => interopDefault(import('../pages/subreddits/index.vue' /* webpackChunkName: "pages/subreddits/index" */))
const _09eb6f1f = () => interopDefault(import('../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _9f0470ba = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _554b02fe = () => interopDefault(import('../pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _3d4212f3 = () => interopDefault(import('../pages/analysis/redditors.vue' /* webpackChunkName: "pages/analysis/redditors" */))
const _8a7a6f88 = () => interopDefault(import('../pages/campaigns/create.vue' /* webpackChunkName: "pages/campaigns/create" */))
const _5633fde8 = () => interopDefault(import('../pages/catch/imgur.vue' /* webpackChunkName: "pages/catch/imgur" */))
const _439af335 = () => interopDefault(import('../pages/dms/create.vue' /* webpackChunkName: "pages/dms/create" */))
const _2b8a2746 = () => interopDefault(import('../pages/dms/inbox.vue' /* webpackChunkName: "pages/dms/inbox" */))
const _0526bf3f = () => interopDefault(import('../pages/features/bulk-import-reddit-posts.vue' /* webpackChunkName: "pages/features/bulk-import-reddit-posts" */))
const _61416643 = () => interopDefault(import('../pages/features/direct-message-automation.vue' /* webpackChunkName: "pages/features/direct-message-automation" */))
const _4d1c5ce6 = () => interopDefault(import('../pages/features/multiple-reddit-accounts.vue' /* webpackChunkName: "pages/features/multiple-reddit-accounts" */))
const _ace0b3fa = () => interopDefault(import('../pages/features/reddit-account-safety.vue' /* webpackChunkName: "pages/features/reddit-account-safety" */))
const _d391bab0 = () => interopDefault(import('../pages/features/reddit-automation.vue' /* webpackChunkName: "pages/features/reddit-automation" */))
const _4a9332ac = () => interopDefault(import('../pages/features/reddit-post-analytics.vue' /* webpackChunkName: "pages/features/reddit-post-analytics" */))
const _212d7cdd = () => interopDefault(import('../pages/features/reddit-post-templates.vue' /* webpackChunkName: "pages/features/reddit-post-templates" */))
const _031646dc = () => interopDefault(import('../pages/features/schedule-reddit-posts.vue' /* webpackChunkName: "pages/features/schedule-reddit-posts" */))
const _367d834e = () => interopDefault(import('../pages/features/subreddit-analysis.vue' /* webpackChunkName: "pages/features/subreddit-analysis" */))
const _2807e780 = () => interopDefault(import('../pages/features/subreddit-manager.vue' /* webpackChunkName: "pages/features/subreddit-manager" */))
const _585a25cc = () => interopDefault(import('../pages/posts/create.vue' /* webpackChunkName: "pages/posts/create" */))
const _dfe0ea34 = () => interopDefault(import('../pages/posts/inbox.vue' /* webpackChunkName: "pages/posts/inbox" */))
const _a857da24 = () => interopDefault(import('../pages/settings/accounts.vue' /* webpackChunkName: "pages/settings/accounts" */))
const _206bb9c7 = () => interopDefault(import('../pages/settings/change-email.vue' /* webpackChunkName: "pages/settings/change-email" */))
const _072ff140 = () => interopDefault(import('../pages/settings/change-password.vue' /* webpackChunkName: "pages/settings/change-password" */))
const _a829b064 = () => interopDefault(import('../pages/settings/checklist.vue' /* webpackChunkName: "pages/settings/checklist" */))
const _79e17184 = () => interopDefault(import('../pages/settings/danger-zone.vue' /* webpackChunkName: "pages/settings/danger-zone" */))
const _2a07b210 = () => interopDefault(import('../pages/settings/notifications.vue' /* webpackChunkName: "pages/settings/notifications" */))
const _623053d8 = () => interopDefault(import('../pages/settings/post-settings.vue' /* webpackChunkName: "pages/settings/post-settings" */))
const _2467f6b6 = () => interopDefault(import('../pages/settings/subscription.vue' /* webpackChunkName: "pages/settings/subscription" */))
const _28202949 = () => interopDefault(import('../pages/use-cases/agencies.vue' /* webpackChunkName: "pages/use-cases/agencies" */))
const _8fe8149a = () => interopDefault(import('../pages/use-cases/fansly.vue' /* webpackChunkName: "pages/use-cases/fansly" */))
const _52d83ed2 = () => interopDefault(import('../pages/use-cases/onlyfans.vue' /* webpackChunkName: "pages/use-cases/onlyfans" */))
const _155cf62e = () => interopDefault(import('../pages/use-cases/youtubers.vue' /* webpackChunkName: "pages/use-cases/youtubers" */))
const _9000a8d4 = () => interopDefault(import('../pages/settings/billing/cancel.vue' /* webpackChunkName: "pages/settings/billing/cancel" */))
const _4c9456ce = () => interopDefault(import('../pages/confirm-email/_token.vue' /* webpackChunkName: "pages/confirm-email/_token" */))
const _32c1280c = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _20f149a0 = () => interopDefault(import('../pages/subreddits/_subredditName.vue' /* webpackChunkName: "pages/subreddits/_subredditName" */))
const _442c2ba8 = () => interopDefault(import('../pages/subscribe/_planCode.vue' /* webpackChunkName: "pages/subscribe/_planCode" */))
const _0680096e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _cd18c29c = () => interopDefault(import('../posts/postpone-v2020.6.5-released.md' /* webpackChunkName: "" */))
const _6a1cd8be = () => interopDefault(import('../posts/reddit-insights-part-1.md' /* webpackChunkName: "" */))
const _7679abb4 = () => interopDefault(import('../posts/postpone-v2020.6.7-released.md' /* webpackChunkName: "" */))
const _64fcb235 = () => interopDefault(import('../posts/postpone-v2020.6.8-released.md' /* webpackChunkName: "" */))
const _95ee9dd0 = () => interopDefault(import('../posts/postpone-v2020.6.10-released.md' /* webpackChunkName: "" */))
const _b8e890ce = () => interopDefault(import('../posts/postpone-v2020.6.11-released.md' /* webpackChunkName: "" */))
const _4abfe86e = () => interopDefault(import('../posts/postpone-v2020.7.0-released.md' /* webpackChunkName: "" */))
const _27c5f570 = () => interopDefault(import('../posts/postpone-v2020.7.2-released.md' /* webpackChunkName: "" */))
const _b6c95aa2 = () => interopDefault(import('../posts/postpone-v2020.8.0-released.md' /* webpackChunkName: "" */))
const _fcbd409e = () => interopDefault(import('../posts/postpone-v2020.8.2-released.md' /* webpackChunkName: "" */))
const _03128620 = () => interopDefault(import('../posts/postpone-v2020.9.0-released.md' /* webpackChunkName: "" */))
const _49066c1c = () => interopDefault(import('../posts/postpone-v2020.9.2-released.md' /* webpackChunkName: "" */))
const _6c005f1a = () => interopDefault(import('../posts/postpone-v2020.9.3-released.md' /* webpackChunkName: "" */))
const _ff756e2e = () => interopDefault(import('../posts/postpone-v2021.1.0-released.md' /* webpackChunkName: "" */))
const _4bbe99ac = () => interopDefault(import('../posts/postpone-v2021.2.0-released.md' /* webpackChunkName: "" */))
const _d7a665a4 = () => interopDefault(import('../posts/postpone-v2021.2.4-released.md' /* webpackChunkName: "" */))
const _faa058a2 = () => interopDefault(import('../posts/postpone-v2021.2.5-released.md' /* webpackChunkName: "" */))
const _33fc1d6b = () => interopDefault(import('../posts/postpone-v2021.3.0-released.md' /* webpackChunkName: "" */))
const _e450f0a8 = () => interopDefault(import('../posts/postpone-v2021.4.0-released.md' /* webpackChunkName: "" */))
const _7c5a8e2d = () => interopDefault(import('../posts/postpone-v2021.4.1-released.md' /* webpackChunkName: "" */))
const _59609b2f = () => interopDefault(import('../posts/postpone-v2021.4.3-released.md' /* webpackChunkName: "" */))
const _24e9aeb2 = () => interopDefault(import('../posts/postpone-v2021.4.6-released.md' /* webpackChunkName: "" */))
const _136cb533 = () => interopDefault(import('../posts/postpone-v2021.4.7-released.md' /* webpackChunkName: "" */))
const _3bb93cd2 = () => interopDefault(import('../posts/rate-limit-issues-fixed.md' /* webpackChunkName: "" */))
const _309a1c26 = () => interopDefault(import('../posts/postpone-v2021.5.0-released.md' /* webpackChunkName: "" */))
const _53940f24 = () => interopDefault(import('../posts/postpone-v2021.5.1-released.md' /* webpackChunkName: "" */))
const _418e5c2e = () => interopDefault(import('../posts/postpone-v2021.6.0-released.md' /* webpackChunkName: "" */))
const _c92c7322 = () => interopDefault(import('../posts/postpone-v2021.7.0-released.md' /* webpackChunkName: "" */))
const _5e21b22c = () => interopDefault(import('../posts/postpone-v2022.1.0-released.md' /* webpackChunkName: "" */))
const _797e476f = () => interopDefault(import('../posts/postpone-v2022.1.5-released.md' /* webpackChunkName: "" */))
const _2aca912b = () => interopDefault(import('../posts/postpone-v2022.2.0-released.md' /* webpackChunkName: "" */))
const _3652a9a2 = () => interopDefault(import('../posts/postpone-v2022.2.4-released.md' /* webpackChunkName: "" */))
const _f6b40928 = () => interopDefault(import('../posts/postpone-v2022.3.0-released.md' /* webpackChunkName: "" */))
const _732901ed = () => interopDefault(import('../posts/postpone-v2022.3.1-released.md' /* webpackChunkName: "" */))
const _61ac086e = () => interopDefault(import('../posts/postpone-v2022.3.2-released.md' /* webpackChunkName: "" */))
const _502f0eef = () => interopDefault(import('../posts/postpone-v2022.3.3-released.md' /* webpackChunkName: "" */))
const _3eb21570 = () => interopDefault(import('../posts/postpone-v2022.3.4-released.md' /* webpackChunkName: "" */))
const _42fd34a6 = () => interopDefault(import('../posts/postpone-v2022.4.0-released.md' /* webpackChunkName: "" */))
const _385ccfee = () => interopDefault(import('../posts/postpone-v2022.5.0-released.md' /* webpackChunkName: "" */))
const _26dfd66f = () => interopDefault(import('../posts/postpone-v2022.5.1-released.md' /* webpackChunkName: "" */))
const _1562dcf0 = () => interopDefault(import('../posts/postpone-v2022.5.2-released.md' /* webpackChunkName: "" */))
const _db8f8ba2 = () => interopDefault(import('../posts/postpone-v2022.6.0-released.md' /* webpackChunkName: "" */))
const _27d8b720 = () => interopDefault(import('../posts/postpone-v2022.7.0-released.md' /* webpackChunkName: "" */))
const _4ad2aa1e = () => interopDefault(import('../posts/postpone-v2022.7.1-released.md' /* webpackChunkName: "" */))
const _45ef0eb1 = () => interopDefault(import('../posts/postpone-v2022.8.0-released.md' /* webpackChunkName: "" */))
const _34721532 = () => interopDefault(import('../posts/postpone-v2022.8.1-released.md' /* webpackChunkName: "" */))
const _11782234 = () => interopDefault(import('../posts/postpone-v2022.8.3-released.md' /* webpackChunkName: "" */))
const _0009ae96 = () => interopDefault(import('../posts/postpone-v2022.8.4-released.md' /* webpackChunkName: "" */))
const _2303a194 = () => interopDefault(import('../posts/postpone-v2022.8.5-released.md' /* webpackChunkName: "" */))
const _c06b0e1c = () => interopDefault(import('../posts/postpone-v2022.9.0-released.md' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/affiliates",
    component: _0522dfda,
    name: "affiliates"
  }, {
    path: "/analysis",
    component: _6772f473,
    name: "analysis"
  }, {
    path: "/analytics",
    component: _16303fbc,
    name: "analytics"
  }, {
    path: "/api-docs",
    component: _3e8adfbc,
    name: "api-docs"
  }, {
    path: "/apply-promo",
    component: _12f1648c,
    name: "apply-promo"
  }, {
    path: "/automation",
    component: _8ab580aa,
    name: "automation"
  }, {
    path: "/blog",
    component: _5c5a4fb9,
    name: "blog"
  }, {
    path: "/BlogPostWrapper",
    component: _41722a66,
    name: "BlogPostWrapper"
  }, {
    path: "/campaigns",
    component: _3e8cdac2,
    name: "campaigns"
  }, {
    path: "/dashboard",
    component: _1b61f830,
    name: "dashboard"
  }, {
    path: "/dms",
    component: _42f6eca9,
    name: "dms"
  }, {
    path: "/features",
    component: _bb23bed8,
    name: "features"
  }, {
    path: "/forgot",
    component: _e5377492,
    name: "forgot"
  }, {
    path: "/import",
    component: _1e45c539,
    name: "import"
  }, {
    path: "/list-of-nsfw-subreddits",
    component: _62f3dfbe,
    name: "list-of-nsfw-subreddits"
  }, {
    path: "/logout",
    component: _fc4226c4,
    name: "logout"
  }, {
    path: "/plans",
    component: _9601a1f4,
    name: "plans"
  }, {
    path: "/privacy",
    component: _a1bfefb8,
    name: "privacy"
  }, {
    path: "/settings",
    component: _1a9bd0fa,
    name: "settings"
  }, {
    path: "/signin",
    component: _6c917ab6,
    name: "signin"
  }, {
    path: "/stats",
    component: _89da128a,
    name: "stats"
  }, {
    path: "/submissions",
    component: _5fd4c9c3,
    name: "submissions"
  }, {
    path: "/subreddits",
    component: _4f796228,
    name: "subreddits"
  }, {
    path: "/success",
    component: _09eb6f1f,
    name: "success"
  }, {
    path: "/terms",
    component: _9f0470ba,
    name: "terms"
  }, {
    path: "/welcome",
    component: _554b02fe,
    name: "welcome"
  }, {
    path: "/analysis/redditors",
    component: _3d4212f3,
    name: "analysis:redditors"
  }, {
    path: "/campaigns/create",
    component: _8a7a6f88,
    name: "campaigns:create"
  }, {
    path: "/catch/imgur",
    component: _5633fde8,
    name: "catch:imgur"
  }, {
    path: "/dms/create",
    component: _439af335,
    name: "dms:create"
  }, {
    path: "/dms/inbox",
    component: _2b8a2746,
    name: "dms:inbox"
  }, {
    path: "/features/bulk-import-reddit-posts",
    component: _0526bf3f,
    name: "features:bulk-import-reddit-posts"
  }, {
    path: "/features/direct-message-automation",
    component: _61416643,
    name: "features:direct-message-automation"
  }, {
    path: "/features/multiple-reddit-accounts",
    component: _4d1c5ce6,
    name: "features:multiple-reddit-accounts"
  }, {
    path: "/features/reddit-account-safety",
    component: _ace0b3fa,
    name: "features:reddit-account-safety"
  }, {
    path: "/features/reddit-automation",
    component: _d391bab0,
    name: "features:reddit-automation"
  }, {
    path: "/features/reddit-post-analytics",
    component: _4a9332ac,
    name: "features:reddit-post-analytics"
  }, {
    path: "/features/reddit-post-templates",
    component: _212d7cdd,
    name: "features:reddit-post-templates"
  }, {
    path: "/features/schedule-reddit-posts",
    component: _031646dc,
    name: "features:schedule-reddit-posts"
  }, {
    path: "/features/subreddit-analysis",
    component: _367d834e,
    name: "features:subreddit-analysis"
  }, {
    path: "/features/subreddit-manager",
    component: _2807e780,
    name: "features:subreddit-manager"
  }, {
    path: "/posts/create",
    component: _585a25cc,
    name: "posts:create"
  }, {
    path: "/posts/inbox",
    component: _dfe0ea34,
    name: "posts:inbox"
  }, {
    path: "/settings/accounts",
    component: _a857da24,
    name: "settings:accounts"
  }, {
    path: "/settings/change-email",
    component: _206bb9c7,
    name: "settings:change-email"
  }, {
    path: "/settings/change-password",
    component: _072ff140,
    name: "settings:change-password"
  }, {
    path: "/settings/checklist",
    component: _a829b064,
    name: "settings:checklist"
  }, {
    path: "/settings/danger-zone",
    component: _79e17184,
    name: "settings:danger-zone"
  }, {
    path: "/settings/notifications",
    component: _2a07b210,
    name: "settings:notifications"
  }, {
    path: "/settings/post-settings",
    component: _623053d8,
    name: "settings:post-settings"
  }, {
    path: "/settings/subscription",
    component: _2467f6b6,
    name: "settings:subscription"
  }, {
    path: "/use-cases/agencies",
    component: _28202949,
    name: "use-cases:agencies"
  }, {
    path: "/use-cases/fansly",
    component: _8fe8149a,
    name: "use-cases:fansly"
  }, {
    path: "/use-cases/onlyfans",
    component: _52d83ed2,
    name: "use-cases:onlyfans"
  }, {
    path: "/use-cases/youtubers",
    component: _155cf62e,
    name: "use-cases:youtubers"
  }, {
    path: "/settings/billing/cancel",
    component: _9000a8d4,
    name: "settings:billing:cancel"
  }, {
    path: "/confirm-email/:token?",
    component: _4c9456ce,
    name: "confirm-email:token"
  }, {
    path: "/reset-password/:token?",
    component: _32c1280c,
    name: "reset-password:token"
  }, {
    path: "/subreddits/:subredditName",
    component: _20f149a0,
    name: "subreddits:subredditName"
  }, {
    path: "/subscribe/:planCode?",
    component: _442c2ba8,
    name: "subscribe:planCode"
  }, {
    path: "/",
    component: _0680096e,
    name: "index"
  }, {
    path: "/blog/post",
    component: _41722a66,
    children: [{
      path: "postpone-v2020.6.5-released",
      component: _cd18c29c,
      meta: {"id":"postpone-v2020.6.5-released","date":"2020-08-09","title":"Postpone v2020.6.5 released!","description":"Today's update introduces the new Postpone blog and includes account management improvements.","tags":["changelog"]},
      name: "blog:postpone-v2020.6.5-released"
    }, {
      path: "reddit-insights-part-1",
      component: _6a1cd8be,
      meta: {"id":"reddit-insights-part-1","date":"2020-08-10","title":"What the Top 2 Million Posts Tell us About Reddit","subtitle":"Part 1 - What to Post","description":"What can 2 million Reddit posts tell us about Reddit itself?","tags":["reddit-insights"]},
      name: "blog:reddit-insights-part-1"
    }, {
      path: "postpone-v2020.6.7-released",
      component: _7679abb4,
      meta: {"id":"postpone-v2020.6.7-released","date":"2020-08-24","title":"Postpone v2020.6.6 and v2020.6.7 released!","description":"Post auto-save, onboarding checklist, bulk delete posts, and more!","tags":["changelog"]},
      name: "blog:postpone-v2020.6.7-released"
    }, {
      path: "postpone-v2020.6.8-released",
      component: _64fcb235,
      meta: {"id":"postpone-v2020.6.8-released","date":"2020-08-30","title":"Postpone v2020.6.8 released!","description":"Post at recommendations, table page sizes, speedier Subreddit Analysis, and more!","tags":["changelog"]},
      name: "blog:postpone-v2020.6.8-released"
    }, {
      path: "postpone-v2020.6.10-released",
      component: _95ee9dd0,
      meta: {"id":"postpone-v2020.6.10-released","date":"2020-09-07","title":"Postpone v2020.6.10 released!","description":"The biggest update to Subreddit Analysis since it was first launched.","tags":["changelog"]},
      name: "blog:postpone-v2020.6.10-released"
    }, {
      path: "postpone-v2020.6.11-released",
      component: _b8e890ce,
      meta: {"id":"postpone-v2020.6.11-released","date":"2020-09-13","title":"Postpone v2020.6.11 released!","description":"Includes improvements to Post Templates, Subreddit Analysis, and more.","tags":["changelog"]},
      name: "blog:postpone-v2020.6.11-released"
    }, {
      path: "postpone-v2020.7.0-released",
      component: _4abfe86e,
      meta: {"id":"postpone-v2020.7.0-released","date":"2020-09-20","title":"Postpone v2020.7.0 released!","description":"Introducing Smart Rescheduling: automatically reschedule failed submissions to Reddit.","tags":["changelog"]},
      name: "blog:postpone-v2020.7.0-released"
    }, {
      path: "postpone-v2020.7.2-released",
      component: _27c5f570,
      meta: {"id":"postpone-v2020.7.2-released","date":"2020-10-04","title":"Postpone v2020.7.2 released!","description":"With major improvements to Post Templates and Bulk Import.","tags":["changelog"]},
      name: "blog:postpone-v2020.7.2-released"
    }, {
      path: "postpone-v2020.8.0-released",
      component: _b6c95aa2,
      meta: {"id":"postpone-v2020.8.0-released","date":"2020-10-11","title":"Postpone v2020.8.0 released!","description":"Automate scheduling posts with Zapier and the Postpone API.","tags":["changelog"]},
      name: "blog:postpone-v2020.8.0-released"
    }, {
      path: "postpone-v2020.8.2-released",
      component: _fcbd409e,
      meta: {"id":"postpone-v2020.8.2-released","date":"2020-10-25","title":"Postpone v2020.8.2 released!","description":"Lots of small improvements and bugs squashed.","tags":["changelog"]},
      name: "blog:postpone-v2020.8.2-released"
    }, {
      path: "postpone-v2020.9.0-released",
      component: _03128620,
      meta: {"id":"postpone-v2020.9.0-released","date":"2020-11-15","title":"Postpone v2020.9.0 released!","description":"Introducing the Postpone Affiliate Program.","tags":["changelog"]},
      name: "blog:postpone-v2020.9.0-released"
    }, {
      path: "postpone-v2020.9.2-released",
      component: _49066c1c,
      meta: {"id":"postpone-v2020.9.2-released","date":"2020-12-06","title":"Postpone v2020.9.2 (The Copy Update) released!","description":"Users can now make copies of their scheduled or submitted posts.","tags":["changelog"]},
      name: "blog:postpone-v2020.9.2-released"
    }, {
      path: "postpone-v2020.9.3-released",
      component: _6c005f1a,
      meta: {"id":"postpone-v2020.9.3-released","date":"2020-12-20","title":"Postpone v2020.9.3 released!","description":"Submit posts to your Reddit profile, bulk import improvements, and more.","tags":["changelog"]},
      name: "blog:postpone-v2020.9.3-released"
    }, {
      path: "postpone-v2021.1.0-released",
      component: _ff756e2e,
      meta: {"id":"postpone-v2021.1.0-released","date":"2021-01-02","title":"Postpone v2021.1.0 released with huge speed improvements!","description":"Postpone just got a lot faster, especially for accounts with lots of posts.","tags":["changelog"]},
      name: "blog:postpone-v2021.1.0-released"
    }, {
      path: "postpone-v2021.2.0-released",
      component: _4bbe99ac,
      meta: {"id":"postpone-v2021.2.0-released","date":"2021-01-24","title":"Postpone v2021.2.0 released!","description":"Link an Imgur account with Postpone and default post settings.","tags":["changelog"]},
      name: "blog:postpone-v2021.2.0-released"
    }, {
      path: "postpone-v2021.2.4-released",
      component: _d7a665a4,
      meta: {"id":"postpone-v2021.2.4-released","date":"2021-02-28","title":"Postpone v2021.2.4 released!","description":"Bulk Import posts with Subreddit Analysis recommendations.","tags":["changelog"]},
      name: "blog:postpone-v2021.2.4-released"
    }, {
      path: "postpone-v2021.2.5-released",
      component: _faa058a2,
      meta: {"id":"postpone-v2021.2.5-released","date":"2021-03-29","title":"Postpone v2021.2.5 released!","description":"Quickly see recent subreddit posting times, upload images to linked Imgur accounts, and more!","tags":["changelog"]},
      name: "blog:postpone-v2021.2.5-released"
    }, {
      path: "postpone-v2021.3.0-released",
      component: _33fc1d6b,
      meta: {"id":"postpone-v2021.3.0-released","date":"2021-04-04","title":"Postpone v2021.3.0 released!","description":"New feature: Log into Postpone with email and password.","tags":["changelog"]},
      name: "blog:postpone-v2021.3.0-released"
    }, {
      path: "postpone-v2021.4.0-released",
      component: _e450f0a8,
      meta: {"id":"postpone-v2021.4.0-released","date":"2021-05-20","title":"Postpone v2021.4.0 released!","description":"New feature: Direct Message automation.","tags":["changelog"]},
      name: "blog:postpone-v2021.4.0-released"
    }, {
      path: "postpone-v2021.4.1-released",
      component: _7c5a8e2d,
      meta: {"id":"postpone-v2021.4.1-released","date":"2021-05-23","title":"Postpone v2021.4.1 released!","description":"Override post titles and view subreddit rules in Postpone.","tags":["changelog"]},
      name: "blog:postpone-v2021.4.1-released"
    }, {
      path: "postpone-v2021.4.3-released",
      component: _59609b2f,
      meta: {"id":"postpone-v2021.4.3-released","date":"2021-06-13","title":"Postpone v2021.4.3 released!","description":"Image preview, improved Subreddit Analysis recommendations, and new Reddit account features.","tags":["changelog"]},
      name: "blog:postpone-v2021.4.3-released"
    }, {
      path: "postpone-v2021.4.6-released",
      component: _24e9aeb2,
      meta: {"id":"postpone-v2021.4.6-released","date":"2021-07-18","title":"Postpone v2021.4.6 released!","description":"Post requirement validation, maximum submission tries, view submission attempts, and a ton more.","tags":["changelog"]},
      name: "blog:postpone-v2021.4.6-released"
    }, {
      path: "postpone-v2021.4.7-released",
      component: _136cb533,
      meta: {"id":"postpone-v2021.4.7-released","date":"2021-08-16","title":"Postpone v2021.4.7 released!","description":"Auto-space submissions, Redditor scores, and more.","tags":["changelog"]},
      name: "blog:postpone-v2021.4.7-released"
    }, {
      path: "rate-limit-issues-fixed",
      component: _3bb93cd2,
      meta: {"id":"rate-limit-issues-fixed","date":"2021-09-11","title":"Rate limit issues fixed!","description":"We've successfully addressed the rate limit issues affecting some accounts.","tags":["news"]},
      name: "blog:rate-limit-issues-fixed"
    }, {
      path: "postpone-v2021.5.0-released",
      component: _309a1c26,
      meta: {"id":"postpone-v2021.5.0-released","date":"2021-09-12","title":"Postpone v2021.5.0 released!","description":"Rate limiting fixed, all new logo, improved announcements, and more!","tags":["changelog"]},
      name: "blog:postpone-v2021.5.0-released"
    }, {
      path: "postpone-v2021.5.1-released",
      component: _53940f24,
      meta: {"id":"postpone-v2021.5.1-released","date":"2021-10-10","title":"Postpone v2021.5.1 released!","description":"View top subreddits and links in Analytics, preview images/GIFs on Dashboard, and more!","tags":["changelog"]},
      name: "blog:postpone-v2021.5.1-released"
    }, {
      path: "postpone-v2021.6.0-released",
      component: _418e5c2e,
      meta: {"id":"postpone-v2021.6.0-released","date":"2021-11-13","title":"Postpone v2021.6.0 released!","description":"Auto-remove posts from Reddit!","tags":["changelog"]},
      name: "blog:postpone-v2021.6.0-released"
    }, {
      path: "postpone-v2021.7.0-released",
      component: _c92c7322,
      meta: {"id":"postpone-v2021.7.0-released","date":"2021-11-28","title":"Postpone v2021.7.0 released!","description":"New Help Center, new support widget, and Bulk Import improvements.","tags":["changelog"]},
      name: "blog:postpone-v2021.7.0-released"
    }, {
      path: "postpone-v2022.1.0-released",
      component: _5e21b22c,
      meta: {"id":"postpone-v2022.1.0-released","date":"2022-01-01","title":"Postpone v2022.1.0 released!","description":"Our big New Years update! Includes Dashboard calendar view, exclude subreddits from DM automation, and lots more.","tags":["changelog"]},
      name: "blog:postpone-v2022.1.0-released"
    }, {
      path: "postpone-v2022.1.5-released",
      component: _797e476f,
      meta: {"id":"postpone-v2022.1.5-released","date":"2022-02-13","title":"Postpone v2022.1.5 released!","description":"Loads of small improvements and bug fixes!","tags":["changelog"]},
      name: "blog:postpone-v2022.1.5-released"
    }, {
      path: "postpone-v2022.2.0-released",
      component: _2aca912b,
      meta: {"id":"postpone-v2022.2.0-released","date":"2022-02-27","title":"Postpone v2022.2.0 released!","description":"Introducing Subreddit Management!","tags":["changelog"]},
      name: "blog:postpone-v2022.2.0-released"
    }, {
      path: "postpone-v2022.2.4-released",
      component: _3652a9a2,
      meta: {"id":"postpone-v2022.2.4-released","date":"2022-04-03","title":"Postpone v2022.2.4 released!","description":"Post Template performance improvements, filter failed submissions, and dozens of enhancements","tags":["changelog"]},
      name: "blog:postpone-v2022.2.4-released"
    }, {
      path: "postpone-v2022.3.0-released",
      component: _f6b40928,
      meta: {"id":"postpone-v2022.3.0-released","date":"2022-05-28","title":"Postpone v2022.3.0 released!","description":"Subreddit quick preview, datepicker post indicators, Bulk Import 2.0, and loads more!","tags":["changelog"]},
      name: "blog:postpone-v2022.3.0-released"
    }, {
      path: "postpone-v2022.3.1-released",
      component: _732901ed,
      meta: {"id":"postpone-v2022.3.1-released","date":"2022-06-05","title":"Postpone v2022.3.1 released!","description":"Per-submission comment overrides, delete Reddit post submissions from Postpone, and bug fixes.","tags":["changelog"]},
      name: "blog:postpone-v2022.3.1-released"
    }, {
      path: "postpone-v2022.3.2-released",
      component: _61ac086e,
      meta: {"id":"postpone-v2022.3.2-released","date":"2022-06-12","title":"Postpone v2022.3.2 released!","description":"Save default flair or comments for subreddits, Grouped and monthly Calendar Dashboard views, and lots more!","tags":["changelog"]},
      name: "blog:postpone-v2022.3.2-released"
    }, {
      path: "postpone-v2022.3.3-released",
      component: _502f0eef,
      meta: {"id":"postpone-v2022.3.3-released","date":"2022-06-19","title":"Postpone v2022.3.3 released!","description":"Per-subreddit auto-remove settings, save posts as templates, and loads more!","tags":["changelog"]},
      name: "blog:postpone-v2022.3.3-released"
    }, {
      path: "postpone-v2022.3.4-released",
      component: _3eb21570,
      meta: {"id":"postpone-v2022.3.4-released","date":"2022-06-27","title":"Postpone v2022.3.4 released!","description":"All new subreddit label picker, Dashboard calendar improvements, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.3.4-released"
    }, {
      path: "postpone-v2022.4.0-released",
      component: _42fd34a6,
      meta: {"id":"postpone-v2022.4.0-released","date":"2022-07-04","title":"Postpone v2022.4.0 released!","description":"Introducing Redditor Analysis and NSFW Subreddit Discovery features.","tags":["changelog"]},
      name: "blog:postpone-v2022.4.0-released"
    }, {
      path: "postpone-v2022.5.0-released",
      component: _385ccfee,
      meta: {"id":"postpone-v2022.5.0-released","date":"2022-07-10","title":"Postpone v2022.5.0 released!","description":"Custom subreddit schedules, crosspost to your profile, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.5.0-released"
    }, {
      path: "postpone-v2022.5.1-released",
      component: _26dfd66f,
      meta: {"id":"postpone-v2022.5.1-released","date":"2022-07-18","title":"Postpone v2022.5.1 released!","description":"Post Template week offsets, plus some bugs are officially squashed.","tags":["changelog"]},
      name: "blog:postpone-v2022.5.1-released"
    }, {
      path: "postpone-v2022.5.2-released",
      component: _1562dcf0,
      meta: {"id":"postpone-v2022.5.2-released","date":"2022-07-24","title":"Postpone v2022.5.2 released!","description":"A guide for succeeding with Postpone and Reddit, a new Reddit Post Submitted trigger in Zapier, and bug fixes!","tags":["changelog"]},
      name: "blog:postpone-v2022.5.2-released"
    }, {
      path: "postpone-v2022.6.0-released",
      component: _db8f8ba2,
      meta: {"id":"postpone-v2022.6.0-released","date":"2022-07-31","title":"Postpone v2022.6.0 released!","description":"Introducing the Postpone Inbox: engage with your Reddit followers across all accounts.","tags":["changelog"]},
      name: "blog:postpone-v2022.6.0-released"
    }, {
      path: "postpone-v2022.7.0-released",
      component: _27d8b720,
      meta: {"id":"postpone-v2022.7.0-released","date":"2022-08-07","title":"Postpone v2022.7.0 released!","description":"Introducing the Post Replies Inbox: quickly respond to comments across all Reddit accounts.","tags":["changelog"]},
      name: "blog:postpone-v2022.7.0-released"
    }, {
      path: "postpone-v2022.7.1-released",
      component: _4ad2aa1e,
      meta: {"id":"postpone-v2022.7.1-released","date":"2022-08-14","title":"Postpone v2022.7.1 released!","description":"Inbox improvements, Bulk Import auto-spacing, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.7.1-released"
    }, {
      path: "postpone-v2022.8.0-released",
      component: _45ef0eb1,
      meta: {"id":"postpone-v2022.8.0-released","date":"2022-08-28","title":"Postpone v2022.8.0 released!","description":"Bulk actions, subreddit verification tracking, randomize DM automation messages, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.8.0-released"
    }, {
      path: "postpone-v2022.8.1-released",
      component: _34721532,
      meta: {"id":"postpone-v2022.8.1-released","date":"2022-08-31","title":"Postpone v2022.8.1 released!","description":"Improved subreddit analysis recommendation spacing, automate DMs only in NSFW subreddits, and bug fixes.","tags":["changelog"]},
      name: "blog:postpone-v2022.8.1-released"
    }, {
      path: "postpone-v2022.8.3-released",
      component: _11782234,
      meta: {"id":"postpone-v2022.8.3-released","date":"2022-09-11","title":"Postpone v2022.8.3 released!","description":"Title autocomplete, subreddit visibility tracking, analytics for posts submitted outside of Postpone, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.8.3-released"
    }, {
      path: "postpone-v2022.8.4-released",
      component: _0009ae96,
      meta: {"id":"postpone-v2022.8.4-released","date":"2022-10-02","title":"Postpone v2022.8.4 released!","description":"Calendar drag 'n' drop, auto-remove profile crossposts, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.8.4-released"
    }, {
      path: "postpone-v2022.8.5-released",
      component: _2303a194,
      meta: {"id":"postpone-v2022.8.5-released","date":"2022-10-09","title":"Postpone v2022.8.5 released!","description":"Per-subreddit title prefixes and suffixes, track pending subreddit verification statuses, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.8.5-released"
    }, {
      path: "postpone-v2022.9.0-released",
      component: _c06b0e1c,
      meta: {"id":"postpone-v2022.9.0-released","date":"2022-10-16","title":"Postpone v2022.9.0 released!","description":"Full crosspost support (schedule crossposts to any subreddit, even across accounts), generate fresh Imgur links, and more!","tags":["changelog"]},
      name: "blog:postpone-v2022.9.0-released"
    }]
  }, {
    path: "/posts/edit/:postId",
    component: _585a25cc,
    props: true,
    name: "posts:edit"
  }, {
    path: "/dms/edit/:dmId",
    component: _439af335,
    props: true,
    name: "dms:edit"
  }, {
    path: "/campaigns/edit/:campaignId",
    component: _8a7a6f88,
    props: true,
    name: "campaigns:edit"
  }, {
    path: "/analysis/subreddit/:subredditName",
    component: _6772f473,
    props: true,
    name: "analysis:name"
  }, {
    path: "/analysis/redditors/:username",
    component: _3d4212f3,
    props: true,
    name: "redditors:name"
  }, {
    path: "/features/analysis",
    component: _367d834e
  }, {
    path: "/features/analytics",
    component: _4a9332ac
  }, {
    path: "/features/automation",
    component: _d391bab0
  }, {
    path: "/features/campaigns",
    component: _212d7cdd
  }, {
    path: "/features/direct-messages",
    component: _61416643
  }, {
    path: "/features/import",
    component: _0526bf3f
  }, {
    path: "/features/safety",
    component: _ace0b3fa
  }, {
    path: "/features/schedule",
    component: _031646dc
  }, {
    path: "/settings",
    component: _1a9bd0fa
  }, {
    path: "/profile",
    component: _1a9bd0fa
  }, {
    path: "/profile/accounts",
    component: _a857da24
  }, {
    path: "/profile/notifications",
    component: _2a07b210
  }, {
    path: "/profile/change-email",
    component: _206bb9c7
  }, {
    path: "/profile/change-password",
    component: _072ff140
  }, {
    path: "/profile/checklist",
    component: _a829b064
  }, {
    path: "/profile/post-settings",
    component: _623053d8
  }, {
    path: "/profile/subscription",
    component: _2467f6b6
  }, {
    path: "/profile/billing/cancel",
    component: _9000a8d4
  }, {
    path: "/help",
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/';
        }
  }, {
    path: "/help/bulk-importing",
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/bulk-import';
        }
  }, {
    path: "/help/linking-accounts",
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/help/linking-additional-reddit-accounts';
        }
  }, {
    path: "/help/post-templates",
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/scheduling-posts/post-templates';
        }
  }, {
    path: "/help/rate-limits",
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/help/rate-limits';
        }
  }, {
    path: "/api-docs",
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/api-docs/postpone-api';
        }
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
